import { createSlice } from '@reduxjs/toolkit';

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  catalogueTitle: '',
  filterRetailer: null,
  sortProductBy: '',
  rspLatestOffer: true,
  rspOption: 'rsp',
  selectedProducts: [],
  originProducts: [],
  selectedData: []
}

const slice = createSlice({
  name: 'generateProductCatalogue',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },

    setCatalogueTitle(state, action) {
      state.isLoading = false;
      state.catalogueTitle = action.payload;
    },

    setFilterRetailer(state, action) {
      state.isLoading = false;
      state.filterRetailer = action.payload;
    },

    setSortProductBy(state, action) {
      state.isLoading = false;
      state.sortProductBy = action.payload;
    },

    setRSPLatestOffer(state, action) {
      state.isLoading = false;
      state.rspLatestOffer = action.payload;
    },

    setRSPOption(state, action) {
      state.isLoading = false;
      state.rspOption = action.payload;
    },

    setSelectedProducts(state, action) {
      state.isLoading = false;
      state.selectedProducts = action.payload;
    },

    setOriginProducts(state, action) {
      state.isLoading = false;
      state.originProducts = action.payload;
    },

    setSelectedData(state, action) {
      state.isLoading = false;
      state.selectedData = action.payload;
    },

    resetGenerateProductCatalogue(state) {
      state.catalogueTitle = '';
      state.filterRetailer = null;
      state.sortProductBy = '';
      state.rspLatestOffer = true;
      state.rspOption = 'rsp';
      state.selectedProducts = [];
      state.originProducts = [];
      state.selectedData = [];
    }
  }
})

// Reducer
export default slice.reducer;

// Actions
export const {
} = slice.actions;

// ----------------------------------------------------------------------

export function setCatalogueTitle(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setCatalogueTitle(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setFilterRetailer(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setFilterRetailer(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSortProductBy(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSortProductBy(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setRSPLatestOffer(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setRSPLatestOffer(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setRSPOption(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setRSPOption(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSelectedProducts(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSelectedProducts(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setOriginProducts(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setOriginProducts(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function setSelectedData(value) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.setSelectedData(value))
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}

export function resetGenerateProductCatalogue() {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading())
    try {
      dispatch(slice.actions.resetGenerateProductCatalogue())
    } catch (error) {
      console.error(error);
      dispatch(slice.actions.hasError(error))
    }
  }
}